/** @jsxImportSource @emotion/react */
import React from 'react';
import * as color from 'style/color';
import cx from 'classnames';
function VerticalCenterBox(props: React.ComponentProps<'div'>) {
  return <div css={{display: 'flex', alignItems: 'center'}} {...props} />;
}

function SpecialText({className, ...props}: React.ComponentProps<'span'>) {
  return (
    <span
      className={cx('text-lg text-brand leading-[27px]', className)}
      {...props}
    />
  );
}

type Props = {
  name: string;
  vat: string;
  amountOfLicense: number;
  amountOfEmployee: number;
};

export default function CompanyInfo({
  name,
  vat,
  amountOfLicense,
  amountOfEmployee,
}: Props) {
  return (
    <div
      className={'company-info'}
      css={{
        background: '#f1f1f2',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '18px 15px 18px',
      }}
    >
      <div className={'text-lg leading-none'}>
        <span className="company-name">{name}</span>
        <SpecialText className="tax-id-number ml-[15px]">{vat}</SpecialText>
      </div>
      <div className={'text-[13px] flex items-center'}>
        <VerticalCenterBox className='text-base'>
          總員工人數：
          <SpecialText
            css={{marginRight: 30}}
            className={'mr-[30px]'}
            data-test-id={'amount-of-employee'}
          >
            {amountOfEmployee}
          </SpecialText>
        </VerticalCenterBox>
        <VerticalCenterBox className='text-base'>
          剩餘員工授權：
          <SpecialText data-test-id={'amount-of-license'}>
            {amountOfLicense - amountOfEmployee}
          </SpecialText>
        </VerticalCenterBox>
      </div>
    </div>
  );
}
